import React, { useEffect, useState } from 'react';
import {
    Container, Table, Header, Popup, Icon
} from 'semantic-ui-react';
import { api } from '#/apis';
import { defaultHeaders, legalHeaders } from '../delinquencies/ViewDelinquencies';
import Dimmer from '+/Dimmer';

const headers = [...defaultHeaders, ...legalHeaders];
// Remove the last header 'DOCUMENTS' because it is not needed
headers.pop();

const ViewFlaggedAccounts = props => {

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [data, setData] = useState(null);
    const [mounted, setMounted] = useState(false);
    // Check that component is mounted before setting state
    useEffect(() => {
        setMounted(true);

        return () => setMounted(false);
    }, []);

    useEffect(() => {
        function fetchData() {

            setLoading(true);
            api.get('/report-data/flagged')
                .then(({ data }) => {
                    setData(data);
                    setLoading(false);
                })
                .catch(err => {
                    setLoading(false);
                    setError(err);
                });
        }

        if (mounted) {
            fetchData();
        }
    }, [mounted]);


    if (loading || error) return <Dimmer message='Loading... This report can take up to 2 minutes' />;

    return (
        <Container fluid className='overflow-x'>
            <div style={{
                display: 'flex',
                alignItems: 'center'
            }}>
                <Header
                    as='h2'
                    content='Flagged Accounts'
                    color='grey'
                    className='no-margin sm-padding-right'
                />
                <Popup content='All delinquencies marked as flagged live here.' trigger={<Icon name='help circle'/>} />
            </div>
            <Table celled singleLine collapsing>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell content='Property' />
                        {headers.map(([title], i) => (
                            <Table.HeaderCell content={title} key={`header-${i}`}/>
                        ))}
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {data
                            && data.map((report, i) => (
                                <Table.Row key={i}>

                                    <Table.Cell content={report.property_name} />
                                    <Table.Cell content={report.bldg_unit} />

                                    <Table.Cell content={report.resident_name} />
                                    <Table.Cell content={report.lease_status} />
                                    <Table.Cell content={report.total_current_due} />
                                    <Table.Cell content={report.total_past_due} />
                                    <Table.Cell content={report.total_delinquent} />
                                    <Table.Cell content={report.payment_status} />
                                    <Table.Cell content={report.data.special_status} />
                                    <Table.Cell content={report.lease_sub_status} />
                                    <Table.Cell content={report.scheduled_rent} />
                                    <Table.Cell content={report.other_scheduled_rent} />
                                    <Table.Cell content={report.data.manager_notes} />
                                    <Table.Cell content={report.data.admin_notes} />
                                    <Table.Cell content={report.data.court_registry} />
                                    <Table.Cell content={report.data.hold_date} />
                                    <Table.Cell content={report.data.held_by} />
                                    <Table.Cell content={report.data.three_day_served} />
                                    <Table.Cell content={report.data.file_date} />
                                    <Table.Cell content={report.data.case_number} />
                                    <Table.Cell content={report.data.summons_served} />
                                    <Table.Cell content={report.data.default_date} />
                                    <Table.Cell content={report.data.motion_to_strike} />
                                    <Table.Cell content={report.data.judgement} />
                                    <Table.Cell content={report.data.writ_of_possession} />
                                    <Table.Cell
                                        content={report.data.twentyfour_hour_notice}
                                    />


                                </Table.Row>
                            ))}
                </Table.Body>
            </Table>
        </Container>
    );
};


export default ViewFlaggedAccounts;
